module.exports = {

    title: '徐记海鲜H5验证助手',

    /**
     * token头
     */
    tokenHead: 'Bearer ',
    /**
     * 认证请求头
     */
    authorization: 'Authorization'

}
